import './FilterTreeVerticalPlaceholder.scss';

import Placeholder from '@components/Placeholder';
import { createClsNameMap } from '@utils';

export const clsNameMap = createClsNameMap({
  elements: {
    group: createClsNameMap(),
  },
})('filter-tree-vertical-placeholder');

export type PlaceholderProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  rows?: number;
};

const FilterTreeVerticalPlaceholder = ({ rows = 3, ...attrs }: PlaceholderProps) => {
  const arr = new Array(rows).fill(null);

  return (
    <div className={clsNameMap.root()} {...attrs}>
      {arr.map((_, i) => {
        return (
          <div key={i} className={clsNameMap.elm('group')}>
            <Placeholder width='80%' />
            <Placeholder />
            <Placeholder width='65%' />
            <Placeholder width='40%' />
          </div>
        );
      })}
    </div>
  );
};

export default FilterTreeVerticalPlaceholder;
